import { Footer } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { MedicalQuestion } from "../../../data-model/medicalQuestion";
import { RootState } from "../../../redux/store/store";
import { handleQuestionnaireSubmit } from "../utils/handleQuestionnaireSubmit";

interface PortalQuestionnaireFooterProps {
  getQuestionnaireAnswers: () => MedicalQuestion[];
  loading: boolean;
  error: boolean;
  hasQuestions: boolean;
  getIsDirty: () => boolean;
}

const PortalQuestionnaireFooter = (props: PortalQuestionnaireFooterProps) => {
  const { data: workflowConfig } = useSelector(
    (state: RootState) => state.workflowConfig,
  );
  const { getQuestionnaireAnswers, loading, error, hasQuestions } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState(false);

  if (!id) return null;

  const handleNavigateBack = () => {
    navigate(`/worklists/singleOrder/${id}`);
  };

  return (
    <Footer
      cancelButtonText="Go Back"
      submitButtonText={submitLoading ? "Submitting..." : "Submit"}
      onCancelClick={handleNavigateBack}
      onSubmitClick={() =>
        handleQuestionnaireSubmit(
          navigate,
          id,
          getQuestionnaireAnswers(),
          setSubmitLoading,
          workflowConfig ?? {},
        )
      }
      isDisabled={loading || !!error || !hasQuestions || submitLoading}
    />
  );
};

export default PortalQuestionnaireFooter;
